"use client";
import {
  useModalFooter
} from "./chunk-272KY7G3.mjs";
import {
  forwardRef
} from "./chunk-TKNQSGPN.mjs";

// src/modal-footer.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var ModalFooter = forwardRef((props, ref) => {
  const {
    Component,
    children,
    leftContent,
    getFooterProps,
    getFooterButtonsProps,
    getFooterLeftContentProps
  } = useModalFooter(props);
  return /* @__PURE__ */ jsxs(Component, { ...getFooterProps(), children: [
    leftContent && /* @__PURE__ */ jsx("div", { ...getFooterLeftContentProps(), children: leftContent }),
    /* @__PURE__ */ jsx("div", { ...getFooterButtonsProps(), children })
  ] });
});
ModalFooter.displayName = "UI.ModalFooter";
var modal_footer_default = ModalFooter;

export {
  modal_footer_default
};
